const styles = {
  wrapper: 'offers flex flex-col justify-between min-w-[120px] h-[65px] mr-4',
  label: 'text-sm text-trueGray',
  value: 'text-xl font-semibold',
  date: 'text-base font-semibold text-trueGray'
};

export default styles;
